import { render, staticRenderFns } from "./g-upload.vue?vue&type=template&id=55580aac"
import script from "./g-upload.vue?vue&type=script&lang=js"
export * from "./g-upload.vue?vue&type=script&lang=js"
import style0 from "./g-upload.vue?vue&type=style&index=0&id=55580aac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports